import { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { setScrollable } from '../../store/actions/drawer.actions'
import styles from './BottomActionBar.module.scss'

const BottomActionBarWrapper = ({ children }) => {
  const containerRef = useRef(null)
  const dispatch = useDispatch()
  const { scrollable } = useSelector(({ drawer }) => drawer)

  useEffect(() => {
    const isVerticalScrollbar = () => {
      const node = containerRef.current
      return node && node.scrollHeight - node.offsetHeight > 0
    }

    const updateScroll = () => {
      if (isVerticalScrollbar() && !scrollable) {
        dispatch(setScrollable(true))
      }
    }
    const handleWindowResize = () => {
      const hasScrollbar = isVerticalScrollbar()
      if (scrollable !== hasScrollbar) {
        setScrollable(hasScrollbar)
      }
    }
    const node = containerRef.current
    if (node) {
      node.addEventListener('scroll', updateScroll)
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      if (node) {
        node.removeEventListener('scroll', updateScroll)
      }
      window.removeEventListener('resize', handleWindowResize)
      setScrollable(false)
    }
  }, [setScrollable])

  return (
    <div
      className={`${styles.wrapper} ${scrollable ? styles.scrollable : ''}`}
      ref={containerRef}
    >
      {children}
    </div>
  )
}

BottomActionBarWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BottomActionBarWrapper
